import { saLimitedReleasesListConstants } from "../_redux-constants";
import { saLimitedReleasesListService } from "../../_services";

function getSaLimitedReleasesList(queryParams) {
  function getSALimitedReleasesListLoad() {
    return {
      type: saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getSALimitedReleasesListSuccess(data) {
    return {
      type: saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getSALimitedReleasesListFailure(error) {
    return {
      type: saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getSALimitedReleasesListLoad());
    return saLimitedReleasesListService
      .getSaLimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getSALimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getSALimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const saLimitedReleasesListActions = {
  getSaLimitedReleasesList,
};
